import packageJson from '../../package.json'

interface AppConfig {
  appEnv: string
  apiUrl: string
  sdkApiUrl: string
  platformApiUrl: string
  platformSalt: string
  environment: string
  enableAnalytics: boolean
  clientId: string
  gameId: number
  gamePlatformId: number
  sentry: {
    dsn: string
    enabled: boolean
  }
  crisp: {
    websiteId: string
  }
  bundleId: string
  admob: {
    appId: string
    enabled: boolean
  }
  version: string
  tracker: {
    adjust: {
      enabled: boolean
      appToken: string
      environment: 'sandbox' | 'production'
    }
    firebase: {
      enabled: boolean
      apiKey: string
      authDomain: string
      projectId: string
      storageBucket: string
      messagingSenderId: string
      appId: string
      measurementId: string
    }
  }
  noctua: {
    secretKey: string
  }
}
export const appConfig: AppConfig = {
  appEnv: import.meta.env.VITE_APP_ENV || '',
  apiUrl: import.meta.env.VITE_API_URL || '',
  sdkApiUrl: import.meta.env.VITE_SDK_API_URL || '',
  platformApiUrl: import.meta.env.VITE_PLATFORM_API_URL || '',
  platformSalt: import.meta.env.VITE_PLATFORM_SALT || '',
  environment: import.meta.env.VITE_ENVIRONMENT || 'development',
  enableAnalytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true' ? true : false,
  clientId: import.meta.env.VITE_CLIENT_ID || '',
  sentry: {
    dsn: import.meta.env.VITE_SENTRY_DSN || '',
    enabled: import.meta.env.VITE_SENTRY_ENABLED === 'true' ? true : false,
  },
  crisp: {
    websiteId: import.meta.env.VITE_CRISP_WEBSITE_ID || '',
  },
  bundleId: import.meta.env.VITE_BUNDLE_ID || '',
  admob: {
    appId: import.meta.env.VITE_ADMOB_APP_ID || '',
    enabled: import.meta.env.VITE_ADMOB_ENABLED === 'true' ? true : false,
  },
  version: packageJson.version,
  tracker: {
    adjust: {
      enabled: import.meta.env.VITE_ADJUST_TRACKER_ENABLED === 'true' ? true : false,
      appToken: import.meta.env.VITE_ADJUST_APP_TOKEN || '',
      environment: import.meta.env.VITE_ADJUST_ENVIRONMENT || 'sandbox',
    },
    firebase: {
      enabled: import.meta.env.VITE_FIREBASE_TRACKER_ENABLED === 'true' ? true : false,
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY || '',
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
      appId: import.meta.env.VITE_FIREBASE_APP_ID || '',
      measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || '',
    },
  },
  noctua: {
    secretKey: import.meta.env.VITE_SECRET_KEY || '',
  },
  gameId: import.meta.env.VITE_GAME_ID || 0,
  gamePlatformId: import.meta.env.VITE_GAME_PLATFORM_ID || 0,
}
